import { render, staticRenderFns } from "./FieldFileBatch.vue?vue&type=template&id=f13fa70c&scoped=true&"
import script from "./FieldFileBatch.vue?vue&type=script&lang=js&"
export * from "./FieldFileBatch.vue?vue&type=script&lang=js&"
import style0 from "./FieldFileBatch.vue?vue&type=style&index=0&id=f13fa70c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13fa70c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f13fa70c')) {
      api.createRecord('f13fa70c', component.options)
    } else {
      api.reload('f13fa70c', component.options)
    }
    module.hot.accept("./FieldFileBatch.vue?vue&type=template&id=f13fa70c&scoped=true&", function () {
      api.rerender('f13fa70c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Fields/FieldFileBatch.vue"
export default component.exports